export default __webpack_public_path__ + "chef-cap23cb38.png";